import React from "react";
import { Trans, withTranslation } from "react-i18next";
import { Translation } from "react-i18next";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import Role from "../../helpers/role";
import { DownloadAttachment } from "../../Actions/AttachmentAPI";
import "primeicons/primeicons.css";
import "primereact/resources/themes/nova-light/theme.css";
import "primereact/resources/primereact.css";
import "primeflex/primeflex.css";
import { Paginator } from "primereact/paginator";
import { OverlayTrigger, Popover } from "react-bootstrap";

let user = localStorage.getItem("UserRoles");

class ClassCard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      first: 0,
    };
  }


  render() {
    const { arraylist,currentPage, pageSize, totalRecords, t } = this.props;
    return (
      <div className="pb-3">
        {this.renderCardData()}
        {arraylist.length != 0 ? (
          <Paginator
            first={currentPage}
            rows={pageSize}
            totalRecords={totalRecords}
            onPageChange={(e) => this.onPaginatorChange(e)}
          ></Paginator>
        ) : (
          <div
            className="card"
            style={{ overflow: "hidden", position: "relative" }}
          >
            <div className="container">
              <h6 className="resource-list-title no-item-card">
                !--{t("CommonText.NoItem")} --!
              </h6>
            </div>
          </div>
        )}
      </div>
    );
  }
  ViewClassDetails(item) {
    const { dispatch, history } = this.props;
    dispatch({ type: "ViewClassDetails", data: item });
    history.push(`/Home/MasterData/ClassDetails/${item.lookUpId}`);
  }
  onPaginatorChange(event) {
    this.setState({
      first: event.first,
    });
    const { setUpdatedState } = this.props;
    setUpdatedState(event.page + 1);
  }
  renderCardData = () => {
    const { showSidePane, arraylist, eyeclick, deleteClass, t } = this.props;
    return arraylist && arraylist.length
      ? arraylist.map((item, index) => {
        return (
          <div
            className="card mb-2"
            style={{ overflow: "hidden", position: "relative" }}
          >
            <div className="p-2">
              <div className="resource-list-auth-date">
                <div className="row">
                  <div className="col-sm-9 col-md-10 col-9 m-auto">
                    <div className="row px-4">
                      <div
                        className={
                          showSidePane ? "col-sm-6 mb-1" : "col-sm-6"
                        }
                      >
                        <span>
                          <strong>{t("ClassScreen.Title")} : </strong>
                          <span
                            className="italicFont"
                            style={{
                              textDecorationLine: item.isDelete
                                ? "line-through"
                                : "none",
                            }}
                          >
                            {item?.lookUpName}{" "}
                          </span>
                        </span>
                      </div>
                      <div
                        className={
                          showSidePane ? "col-sm-6 mb-1" : "col-sm-6"
                        }
                      >
                        <span>
                          <strong>{t("FlagScreen.Attachment")} : </strong>
                          <span className="italicFont ">
                            {item.classAttachmentName ? item.classAttachmentName : " - "}{" "}
                          </span>
                          {item.classAttachmentName ? (
                            <i
                              className="fa fa-download click ml-1"
                              onClick={() =>
                                this.DownloadDoc(
                                  item.classAttachmentName,
                                  item.classAttachmentGuid
                                )
                              }
                              aria-hidden="true"
                              style={{
                                color: " #1a3464",
                                fontSize: "1.2rem",
                              }}
                            ></i>
                          ) : (
                            ""
                          )}
                        </span>
                      </div>
                    </div>
                  </div>

                  {!item.isDeleted ? (
                    <div className="col-md-2 col-sm-3 col-3 m-auto">
                      <div className="text-right">
                        <OverlayTrigger
                          placement="bottom"
                          delay={{ show: 250, hide: 400 }}
                          overlay={this.renderedit()}
                        >
                          <i
                            className="fa fa-edit fa-lg click m-1 px-1"
                            onClick={() => eyeclick(item)}
                            aria-hidden="true"
                            style={{ color: " #1a3464", fontSize: "1.8rem" }}
                          ></i>
                        </OverlayTrigger>

                        <OverlayTrigger
                          placement="bottom"
                          delay={{ show: 250, hide: 400 }}
                          overlay={this.renderdelete()}
                        >
                          <i
                            className="fa fa-trash click m-1 px-2"
                            onClick={() => deleteClass(item)}
                            aria-hidden="true"
                            style={{ color: " #1a3464", fontSize: "1.8rem" }}
                          ></i>
                        </OverlayTrigger>
                      </div>
                    </div>
                  ) : (
                    <div className="my-3"></div>
                  )}
                </div>
              </div>
            </div>
          </div>
        );
      })
      : null;
  };

  renderedit(props) {
    return (
      <Popover id="history-tooltip" {...props}>
        <Popover.Content>
          <label style={{ padding: "0px 10px" }}>{this.props.t("IntervelScreen.Edit")}</label>
        </Popover.Content>
      </Popover>
    );
  }

  renderdelete(props) {
    return (
      <Popover id="history-tooltip" {...props}>
        <Popover.Content>
          <label style={{ padding: "0px 10px" }}>{this.props.t("CommonText.Delete")}</label>
        </Popover.Content>
      </Popover>
    );
  }


  DownloadDoc(attachmentName, attachmentGuid) {
    this.props.dispatch(DownloadAttachment(attachmentName, attachmentGuid));
  }
}

function mapStateToProps(state) {
  return {
    showSidePane: state.SidePanReducer.sidePan || false,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dispatch,
  };
}

export default withTranslation()(
  withRouter(connect(mapStateToProps, mapDispatchToProps)(ClassCard))
);
